import { render, staticRenderFns } from "./preview-event.vue?vue&type=template&id=71e8758f&"
import script from "./preview-event.vue?vue&type=script&lang=js&"
export * from "./preview-event.vue?vue&type=script&lang=js&"
import style0 from "./preview-event.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports